var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "skill" }, [
    _c("div", { staticClass: "skill__wrapper" }, [
      _c(
        "div",
        { staticClass: "skill__value" },
        [
          _c("c-select", {
            attrs: {
              type: "select",
              "floating-label": _vm.skillLabel,
              searchable: true,
              items: _vm.options,
              "custom-options": _vm.config.param.custom,
              "required-mark": _vm.config.required,
              clearable: true,
              invalid: _vm.error && !!_vm.error.value,
              error: _vm.error && _vm.error.value,
            },
            model: {
              value: _vm.item.value,
              callback: function ($$v) {
                _vm.$set(_vm.item, "value", $$v)
              },
              expression: "item.value",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "skill__level" },
        [
          _c("c-select", {
            attrs: {
              type: "select",
              "floating-label": "Уровень",
              searchable: true,
              items: _vm.levelOptions,
              "custom-options": _vm.config.level.custom,
              "required-mark": _vm.config.required,
              clearable: true,
              invalid: _vm.error && !!_vm.error.level,
              error: _vm.error && _vm.error.level,
            },
            model: {
              value: _vm.item.level,
              callback: function ($$v) {
                _vm.$set(_vm.item, "level", $$v)
              },
              expression: "item.level",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "skill__remove" },
        [
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Удалить",
                  placement: "top",
                },
                expression:
                  "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                modifiers: { html: true },
              },
            ],
            staticClass: "lg",
            attrs: { size: "iconic", icon: "trash" },
            on: {
              click: function ($event) {
                return _vm.$emit("remove")
              },
            },
          }),
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Удалить",
                  placement: "top",
                },
                expression:
                  "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                modifiers: { html: true },
              },
            ],
            staticClass: "sm",
            attrs: { label: "Удалить", size: "small", icon: "trash" },
            on: {
              click: function ($event) {
                return _vm.$emit("remove")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }